import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/homepage';

export default function LatestUpdateSection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-12">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              最新更新
              <br />
              精彩不停
            </h2>
          </div>
          <div className="md:pt-2">
            <p className="text-sm text-foreground-500 leading-relaxed max-w-xs">
              每日追踪热门韩漫更新
              <br />
              不错过任何精彩内容
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          <Link
            to="/category/all"
            className="group md:col-span-1 bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
          >
            <div className="w-full aspect-[16/10] overflow-hidden">
              <img
                src={latestUpdates[0].cover}
                alt={latestUpdates[0].title}
                title={`${latestUpdates[0].title} - 韩漫在线最新更新`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
              />
            </div>
            <div className="p-4 md:p-5">
              <h3 className="text-base font-semibold text-foreground-950 mb-1 whitespace-nowrap">
                {latestUpdates[0].title}
              </h3>
              <p className="text-xs text-foreground-500 whitespace-nowrap">
                {latestUpdates[0].latestChapter} · {latestUpdates[0].updateTime}
              </p>
            </div>
          </Link>

          <div className="md:col-span-2 grid grid-cols-1 gap-4">
            {latestUpdates.slice(1).map((item) => (
              <Link
                key={item.id}
                to="/category/all"
                className="group flex items-center gap-4 bg-background-50 rounded-xl p-4 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="w-20 h-14 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} - 韩漫在线最新更新`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1 truncate whitespace-nowrap">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 whitespace-nowrap">
                    {item.category} · {item.latestChapter} · {item.updateTime}
                  </p>
                </div>
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors text-lg" />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}